import TabModel from 'models/utils/common/tab-model';

export const ADMIN_MODULE_SORT_COLUMN_KEYS = {
  clientName: 'clientName',
  containerCode: 'containerCode',
};

export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
};

export const ADMIN_MODULE_TABS = {
  MANAGEUSERS: new TabModel({
    id: 1,
    apiParam: 'manageuserstab',
    intlTitle: 'admin-module.tabs.manageuserstab',
  }),
  MAINTENANCEBANNER: new TabModel({
    id: 2,
    apiParam: 'maintenancebannertab',
    intlTitle: 'admin-module.tabs.maintenancebannertab',
  }),
  SUMMARY_OF_KEY_CHANGES: new TabModel({
    id: 3,
    apiParam: 'summaryOfKeyChangesTab',
    intlTitle: 'admin-module.tabs.summary-of-key-changes',
  }),
  MONITORING: new TabModel({
    id: 4,
    apiParam: 'monitoringTab',
    intlTitle: 'admin-module.tabs.monitoring',
  }),
};

export const getAdminModuleTabs = (currentUser) => {
  // eslint-disable-next-line no-constant-condition
  if (currentUser.applicationManager && currentUser.admin) {
    return {
      MANAGEUSERS: ADMIN_MODULE_TABS.MANAGEUSERS,
      MAINTENANCEBANNER: ADMIN_MODULE_TABS.MAINTENANCEBANNER,
      SUMMARY_OF_KEY_CHANGES: ADMIN_MODULE_TABS.SUMMARY_OF_KEY_CHANGES,
      MONITORING: ADMIN_MODULE_TABS.MONITORING,
    };
  } else if (currentUser.applicationManager) {
    return {
      MAINTENANCEBANNER: ADMIN_MODULE_TABS.MAINTENANCEBANNER,
      SUMMARY_OF_KEY_CHANGES: ADMIN_MODULE_TABS.SUMMARY_OF_KEY_CHANGES,
    };
  } else if (currentUser.admin) {
    return {
      MANAGEUSERS: ADMIN_MODULE_TABS.MANAGEUSERS,
      MONITORING: ADMIN_MODULE_TABS.MONITORING,
    };
  } else {
    return { MANAGEUSERS: ADMIN_MODULE_TABS.MANAGEUSERS };
  }
};
